module.exports = __webpack_public_path__ + "static/img/SA.47cb725.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/countryFlag/SA.svg
// module id = Y9GJ
// module chunks = 66